export default __webpack_public_path__ + "static/media/20-03-2021_Mise_en_ligne_du_site.a7f24295.md";